// How many rows to show per page by default
export const TABLE_ROW_COUNT_DEFAULT = 25;
// Row count options for tables
export const TABLE_ROW_COUNT_OPTIONS = [25, 50, 100];
// Table pagination label
export const LABEL_ROWS_PER_PAGE = 'Sorok száma oldalanként:';

// Roles
export const ROLES = Object.freeze({
    ADMIN: 'admin',
    USER: 'user',
});

// Languages
export const LANG = ['hu', 'en'];

// Paid statuses
export const PAID_STATUSES = Object.freeze({
    ALL: 'Összes',
    PAID: 'Fizetve',
    NOT_PAID: 'Nem fizetve',
});
